import { render, staticRenderFns } from "./successTip.vue?vue&type=template&id=0b246346&scoped=true&"
import script from "./successTip.vue?vue&type=script&lang=js&"
export * from "./successTip.vue?vue&type=script&lang=js&"
import style0 from "./successTip.vue?vue&type=style&index=0&id=0b246346&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b246346",
  null
  
)

component.options.__file = "successTip.vue"
export default component.exports